import React from 'react';
import CreatePortal from './CreatePortal';
import closeIcon from '../../assets/icons/cross-icon.svg';
import { twMerge } from 'tailwind-merge';

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  header?: React.ReactNode;
  children: React.ReactNode | React.ReactNode[];
  headerText?: string;
  position?: 'center' | 'top';
  className?: string;
  crossIcon?: boolean;
}
function Modal({
  isOpen,
  headerText,
  onClose,
  children,
  header,
  position,
  crossIcon = true,
  className,
}: ModalProps) {
  const handleModalClose = () => {
    if (!!onClose) onClose();
  };
  const modalPosition = position === 'center' ? 'items-center' : 'items-start';

  let mergedClasses = twMerge(
    `mt-3 bg-white min-w-[546px] rounded-[20px] overflow-hidden min-h-[200px] relative top-3 pt-1
     ${className ?? ''}`
  );
  return (
    <div>
      {isOpen && (
        <CreatePortal wrapperId="modals-wrapper">
          <div
            className={`bg-[#231f20a6] fixed top-0 left-0 w-full h-full max-h-screen justify-center ${modalPosition} flex z-50`}
          >
            <div className={mergedClasses}>
              {!header ? (
                <div className="pt-1 pb-2 px-4 w-full h-7">
                  {headerText && <h1 className="inline">{headerText}</h1>}
                  {crossIcon ? (
                    <img
                      src={closeIcon}
                      alt="close modal"
                      className="w-3 pt-1 cursor-pointer float-right"
                      onClick={handleModalClose}
                    />
                  ) : null}
                </div>
              ) : (
                header
              )}
              {children}
            </div>
          </div>
        </CreatePortal>
      )}
    </div>
  );
}

export default Modal;
